exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 400px) {\n.modal-content[data-v-d43bd650] {\n    padding-left: 20px;\n    padding-right: 20px;\n}\n}\n.redirect-error[data-v-d43bd650] {\n  background-color: #eb5757;\n  color: #fff;\n}\n", ""]);

// exports
